module.exports = __webpack_public_path__ + "img/clock.1a2009e7.svg";